import { useState, useEffect, useCallback } from 'react'
import { pointService } from '../services/pointService'
import type { Point } from '../types'

/**
 * Loads all point transactions for a specific client.
 */
export function useClientPoints(clientId: number) {
  const [data, setData] = useState<Point[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const points = await pointService.getByClientId(clientId)
      // Sort by transaction date descending
      const sorted = [...points].sort(
        (a, b) =>
          new Date(b.datetime_transaction).getTime() - new Date(a.datetime_transaction).getTime(),
      )
      setData(sorted)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar puntos')
    } finally {
      setIsLoading(false)
    }
  }, [clientId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, isLoading, error, refetch: fetchData }
}
